import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

export function PageTitle({ title, subtitle, action }) {
  return <div className="page-title"><div><h2>{title}</h2><p>{subtitle}</p></div>{action}</div>;
}

export function Card({ children, className = '' }) {
  return <section className={`card ${className}`}>{children}</section>;
}

export function Status({ children, tone = 'neutral' }) {
  return <span className={`status status-${tone}`}>{children}</span>;
}

export function IconButton({ icon = FiIcons.FiMoreHorizontal, label, onClick, className = '' }) {
  return <button className={`icon-button ${className}`} aria-label={label} title={label} onClick={onClick}><SafeIcon icon={icon} /></button>;
}

export function EmptyState({ title, detail }) {
  return <div className="empty-state"><span><SafeIcon icon={FiIcons.FiInbox} /></span><b>{title}</b><p>{detail}</p></div>;
}

export function formatDate(date, options = {}) {
  if (!date) return '—';
  return new Intl.DateTimeFormat('ja-JP', { timeZone: 'Asia/Tokyo', ...options }).format(new Date(date));
}

export function scoreTone(rank) {
  return rank === 'A' ? 'success' : rank === 'B' ? 'warning' : 'muted';
}
